export function importErrorMessage(error, fallback = "Upload failed") {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string" && detail.trim()) return detail;
  if (Array.isArray(detail)) {
    const messages = detail
      .map(item => typeof item === "string" ? item : item?.msg)
      .filter(Boolean);
    if (messages.length) return messages.join("; ");
  }
  const responseMessage = error?.response?.data?.message;
  if (typeof responseMessage === "string" && responseMessage.trim()) return responseMessage;
  if (error?.code === "ECONNABORTED") return "The CAS preview timed out. Please try again.";
  if (error?.message === "Network Error") {
    return "Capital360 could not reach the import service. Please try again in a moment.";
  }
  return fallback;
}
